import { render, staticRenderFns } from "./MediakitMediumCard.vue?vue&type=template&id=a37bc0e8&scoped=true&"
import script from "./MediakitMediumCard.vue?vue&type=script&lang=js&"
export * from "./MediakitMediumCard.vue?vue&type=script&lang=js&"
import style0 from "./MediakitMediumCard.vue?vue&type=style&index=0&id=a37bc0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37bc0e8",
  null
  
)

export default component.exports